import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createIraApplicationAccountNumber,
  updateIraApplicationAccountNumber,
} from '../store/actions/iraFunding/iraFundingActions';
import useApplicationUid from './useApplicationUid';

const useCustodianAccountNumberDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const custodianAccountNumberDispatch = ({
    data,
    defaultValues,
    onSuccess,
  }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data,
      onSuccess,
    };

    if (defaultValues.AccountNumber) {
      dispatch(
        updateIraApplicationAccountNumber({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createIraApplicationAccountNumber({
        ...requestData,
      }),
    );
  };

  return { custodianAccountNumberDispatch };
};

export default useCustodianAccountNumberDispatch;
